import { useMemo } from 'react';
import { evaluatePassword } from '../utils/password';
import { useI18n } from '../i18n';

export default function PasswordStrengthMeter({ password }: { password: string }) {
  const { t } = useI18n();
  const strength = useMemo(() => evaluatePassword(password, t), [password, t]);
  if (password.length === 0) return null;
  return (
    <div className="mt-2.5 space-y-1.5">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors ${i < strength.score ? strength.color : 'bg-gray-200'}`} />
        ))}
      </div>
      <div className="flex justify-between items-center text-[11px]">
        <span className="text-zce-gray-muted">{t('team_reset_strength')}
          <strong className="ml-1 text-zce-navy">{strength.label}</strong>
        </span>
      </div>
      {strength.hints.length > 0 && (
        <ul className="text-[11px] text-zce-gray-muted space-y-0.5 mt-1">
          {strength.hints.map((h) => (
            <li key={h} className="flex items-center gap-1"><span className="text-amber-500">•</span> {h}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
